import * as React from "react";

;
export const PopoverOpen = (props: React.SVGProps<SVGSVGElement>) => <svg width={16} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect y={0.5} width={16} height={16} rx={4} fill="#3FD899" /><path d="M8 12.5L4.103 5.75h7.794L8 12.5z" fill="#fff" /></svg>;